<app-section-quick-actions section="spirit" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Elusive Spirits</h1>
</header>

<div class="atmos-page__intro">
  <p class="atmos-paragraph atmos-page__hint">
    On this page you can find the most elusive season spirits. The spirits that have been missing for the longest time are shown at the top.<br/>
    Please keep in mind that traveling spirit visits are mostly random, so use this data at your own discretion.
  </p>
  <p class="atmos-paragraph atmos-page__hint">
    A graph version of this data is available on the <a routerLink="/graph/spirit" class="atmos-text-link">Graphs - Spirits</a> page.
  </p>
</div>

<div class="atmos-card atmos-elusive__grid-card">
  <ag-grid-angular
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [theme]="theme"
    [getRowHeight]="getRowHeight"
    [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)" />
</div>
